import * as Popover from "@radix-ui/react-popover";

import { styled } from "../../../../../../styles";

export const StyledPopoverTrigger = styled(Popover.Trigger, {
  position: "absolute",

  // The modal close (X) is positioned relative to the modal content, but this
  // trigger is positioned relative to SpirometryContainer, which sits lower
  // (the modal's 12px top padding). These offsets sit this button in the same
  // vertical band as the X, just to its left, so their icons line up.
  top: -3,
  right: 38,
  zIndex: 1,

  // Match the modal close (X) button: a 30x30 CustomIconButton wrapping a
  // 16x16 icon, so the two icons share the same vertical centre and sit level.
  height: "30px",
  width: "30px",
  borderRadius: "$round",

  display: "flex",
  alignItems: "center",
  justifyContent: "center",

  border: "none",
  backgroundColor: "transparent",
  cursor: "pointer",

  "&:hover": {
    backgroundColor: "$gray-50",
  },

  "&:disabled": {
    cursor: "default",
    opacity: 0.4,
  },

  "@sm": {
    position: "relative",
    top: 0,
    right: 0,
    transform: "rotate(90deg)",
  },
});

export const StyledPopoverContent = styled(Popover.Content, {
  zIndex: 3000,
});

export const OptionsContainer = styled("div", {
  background: "$white",

  borderRadius: "12px",
  border: "1px solid $gray-50",
  boxShadow: "0px 0px 2px rgba(0, 0, 0, 0.12)",

  width: "208px",

  "@sm": {
    marginRight: "40px",
    marginTop: "4px",
  },
});

export const OptionItem = styled("div", {
  padding: "16px 28px",

  display: "flex",

  alignItems: "center",
  justifyContent: "space-between",

  p: {
    fontFamily: "$openSans",
    fontWeight: 400,
    fontSize: "$text-sm",

    lineHeight: "16px",
    color: "$charcoal",
  },
});

export const ExportItem = styled("button", {
  all: "unset",
  boxSizing: "border-box",

  width: "100%",
  padding: "16px 28px",

  display: "flex",
  alignItems: "center",
  justifyContent: "flex-start",

  cursor: "pointer",
  // Only the bottom corners follow the container's radius; the top edge stays
  // square so the hover state doesn't round off against the item above it.
  borderRadius: "0 0 12px 12px",

  // When the export is the only item in the menu, round the top corners too so
  // it still matches the container.
  "&:first-child": {
    borderRadius: "12px",
  },

  fontFamily: "$openSans",
  fontWeight: 400,
  fontSize: "$text-sm",
  lineHeight: "16px",
  color: "$charcoal",

  "&:hover": {
    background: "$gray-30",
  },

  "&:disabled": {
    cursor: "default",
    opacity: 0.5,
  },
});
